import {DataQuery, StringUtil} from "cartovista";
import SearchableTreeView from "../appTools/SearchableTreeView";
import {updateColumnsWithStoreValues} from "../stores/LayersUpdater";
import "../../css/Filter.css";﻿

    export default class Filter extends SearchableTreeView{
      constructor(html = '<div id="Filter_container">' +
                                    '<div class="row" style="width:100%; margin:0; justify-content: space-between;">' +
                                        '<div class="col-sm-9" style="padding-left:0;">' +
                                            '<h5>' +
                                                '<strong>Visualiser les ' + C.PANELS.FILTER.TITLE_NAMES.TYPE_LIEU + ' offrant les ' + C.PANELS.FILTER.TITLE_NAMES.NOM_SELECTION + '</strong>' +
                                            '</h5>' +
                                        '</div>' +
                                    '</div>' +
                                    '<div class="form-group">' +
                                        '<div class="btn-group" role="group">' +
                                             '<button id="Filter_selectAllSearchBtn" type="button" class="btn btn-outline-primary" disabled>Ajouter la recherche à la sélection</button>' +
                                            '<button id="Filter_selectAllBtn" type="button" class="btn btn-outline-primary">Désélectionner tout</button>' +
                                        '</div>' +
                                    '</div>' +
                                    '<div class="form-group">' +
                                       '<p><i id="Filter_nbSelectedLbl"></i></p>' +
                                    '</div>' +
                                    '<div class="form-group" id="Filter_searchableTreeView"></div>' +
                                '</div>') {
        super(false, false, false, {
            checkChildren: true, 
        });
        this._$searchableTreeView = this._$container;
        this._$container = $(html);
        this._$container.find("#Filter_searchableTreeView").html(this._$searchableTreeView);

        $("#Filter_panel_btn").html('<span class="cv-icon">w</span>');

        this.genericView = window.cartovista.getUIController(this._map).findInstance("Filter_panel");
        this.genericView._activated = this._activated.bind(this);

        $(this.genericView.element).html(this._$container);
        
        this._$selectAllSearchBtn = this._$container.find("#Filter_selectAllSearchBtn");
        this._$selectAllSearchBtn.click(this._onSelectAllSearchBtnClick.bind(this));
        this._$nbSelectedLbl = this._$container.find("#Filter_nbSelectedLbl");
        this._$selectAllBtn = this._$container.find("#Filter_selectAllBtn");
        this._$selectAllBtn.click(this._onSelectAllBtnClick.bind(this));
        
        this._dataSource.read();
        _.forEach(this._dataSource.data(), (dataItem) => dataItem.set("checked", true));
        this._listSearch.trigger("check");

        this.total = this._getCheckedChildren(this._dataSource.data()).length;
      }

      _activated() {
        this._$searchInput.focus();
    };

    _iter(dataSource, id) {
        var dataItem = dataSource.get(id);
        if (dataItem.children.data()) {
            return this._iter(dataItem.children, id);
        } else{
            return dataItem.iter + 1;
        }
    };

    _getStoreData(iter, data, treeConfig, stores){
        if(iter == 0){
            var storeFilter = {};
        } else{
            var storeFilter = _.reduce(_.split(data.id, "---"), function(result, id, index){
                result[treeConfig[index].ID] = id;
                return result;
            }, {});
        }
        if(stores){
            var column = treeConfig[iter];
            var storeItems = _.flatten(_.map(stores, (store) => window[store].getItems(storeFilter)));
            return _.map(_.sortBy(_.uniqBy(storeItems, column.ID), [column.ID]), function(storeItem){
                var id = _.map(_.slice(treeConfig, 0, iter + 1), (col) => storeItem[col.ID]).join("---");
                var value = column.USE_ID ? storeItem[column.ID] + " - " + storeItem.attributes[column.TEXT] : storeItem.attributes[column.TEXT];
                return {
                    text: value,
                    id: id,
                    filterText: StringUtil.foldAccents(value),
                    treeConfig: treeConfig,
                    stores: stores,
                    iter: iter,
                    filterColumn: iter != treeConfig.length - 1 ? null : column.ID,
                    hasChildren: iter != treeConfig.length - 1
                };
            }.bind(this));
        } else if(treeConfig){
            return treeConfig; //ITEMS not in store, but in config
        }
    }

    _createData(e, iter, treeConfig, stores){
        if(treeConfig[0] && typeof treeConfig[0].TREE_DATACOLUMNS != "undefined"){
            return _.map(treeConfig, function(treeDataColumnConfig, idx){
                return {
                        text: treeDataColumnConfig.TITLE,
                        id: typeof treeDataColumnConfig.ID != "undefined" ? treeDataColumnConfig.ID : treeDataColumnConfig.TITLE,
                        treeConfig: treeDataColumnConfig.TREE_DATACOLUMNS.length ? treeDataColumnConfig.TREE_DATACOLUMNS : (typeof treeDataColumnConfig.ITEMS != "undefined" ? treeDataColumnConfig.ITEMS : null),
                        stores: typeof treeDataColumnConfig.STORES != "undefined" ? treeDataColumnConfig.STORES : null,
                        iter: Array.isArray(iter) ? iter[idx] : iter,
                        hasChildren: true
                    };
            }.bind(this));
        } else{
            return this._getStoreData(iter, e.data, treeConfig, stores);
        }
    }

    _findIterDeep(treeConfig, iter){
        if(treeConfig[0] && typeof treeConfig[0].TREE_DATACOLUMNS != "undefined"){
            iter--;
           return  _.map(treeConfig, function(treeDataColumnConfig, idx){
                var iters = this._findIterDeep(treeDataColumnConfig.TREE_DATACOLUMNS, iter);//all values must be the same if array
                return Array.isArray(iters) ? iters[0] : iters;
            }.bind(this));
        } else{
            return iter;
        }
    }

      _kendoTransportRead(e) {
            if(typeof e.data.id !== "undefined"){
                var iter = this._iter(this._dataSource, e.data.id);
                var dataItem = this._dataSource.get(e.data.id);
                var treeConfig = dataItem.treeConfig;
                var stores = dataItem.stores;
            } else{
                var iter = 0;
                var treeConfig = C.PANELS.FILTER.TREE_DATACOLUMNS;
                var stores = [C.PANELS.FILTER.STORE];
                if(typeof C.PANELS.FILTER.TREE_DATACOLUMNS[0].TREE_DATACOLUMNS != "undefined"){
                    iter = this._findIterDeep(C.PANELS.FILTER.TREE_DATACOLUMNS, iter);
                }
            }
            e.success(this._createData(e, iter, treeConfig, stores));
    };

      _onCheckChanged_listSearch(dataItem){
        var selectedDataItems = super._onCheckChanged_listSearch(dataItem);
        this._$nbSelectedLbl.text(selectedDataItems.length + " " + C.PANELS.FILTER.TITLE_NAMES.NOM_SELECTION);
        if(this.total == selectedDataItems.length){
            this._$selectAllBtn.text("Désélectionner tout");
        } else{
            this._$selectAllBtn.text("Sélectionner tout");
        }
        var selectedItems = _.map(selectedDataItems, function(node){
            var value = node.iter ? _.split(node.id, "---")[node.iter] : node.id;
            return {[node.filterColumn]: value};
        });
        _.forEach(C.PANELS.FILTER.DATACOLUMNS_TO_UPDATE, function(updateConfig) {
            updateConfig.JOIN.FILTER = selectedItems;
            updateColumnsWithStoreValues(updateConfig);
        }.bind(this));
        if(C.PANELS.FILTER.UPDATE_THEMESET){
            this._updateThemeSet(C.PANELS.FILTER.UPDATE_THEMESET);
        }
      }

    _onSelectAllSearchBtnClick(evt) {
        this._$searchableTreeView.find(".k-checkbox-wrapper input").prop("checked", true).trigger("change");
    };

    _refreshResults() {
        super._refreshResults();
        if(this._$searchInput.val() != ""){
            this._$selectAllSearchBtn.prop('disabled', false);
        }
        else{
          this._$selectAllSearchBtn.prop('disabled', true);
        }
    };

    _onSelectAllBtnClick(evt) {
        if(this._$selectAllBtn.text() == "Sélectionner tout"){
            this._$selectAllBtn.text("Désélectionner tout");
            this._checkChildren(this._dataSource, true);
            this._listSearch.trigger("check");
        } else if(this._$selectAllBtn.text() == "Désélectionner tout"){
            this._$selectAllBtn.text("Sélectionner tout");
            this._checkChildren(this._dataSource, false);
            this._listSearch.trigger("check");
        }
    };

    _updateThemeSet(config) {
        var map = window.cartovista.externalInterface.map;
        var themeSetGroup = map.getThemeSetGroup(config.THEMESET_ID);
        this._changeSizeTheme(themeSetGroup);
        if (map.activeThemeSet) {
            var themeSet = map.activeThemeSet;
            themeSet.unapply();
            themeSet.applyThemeSet();

            //fix pour _styleThemeOverride != null
            if(!themeSet.themeCount){
                themeSet.selectedSearchLayer.getSimpleFeatures(null, function(response){
                    _.forEach(response.features, function(feature){
                        feature._styleThemeOverride = null;
                    });
                }, this);
            }
        }
    };

    _changeSizeTheme(themeSetGroup) {
        _.forEach(themeSetGroup.themeSetElements, function(themeSetElement) {
            if(themeSetElement.toString() == "ThemeSetGroup"){
                this._changeSizeTheme(themeSetElement);
            }
            else{
                for(var i = 0; i < themeSetElement.themeCount; i++){
                    var theme = themeSetElement.getThemeByIndex(i);
                    theme.sizeTheme._representations = [];
                    var minMax = this._findMinMaxValues(theme.interactiveLayer, theme.sizeTheme.dataColumn);
                    theme.sizeTheme.maxValue = minMax.MAX;
                    theme.sizeTheme.minValue = minMax.MIN;
                }
            }
        }.bind(this));
    };

    _findMinMaxValues(layer, dataColumn) {
        var min, max;
        var query = new DataQuery([dataColumn]).execute(function(queryResult) {
            var nbTotInsc = queryResult.values[dataColumn.dataTable.id][dataColumn.id];
            min = _.min(nbTotInsc);
            max = _.max(nbTotInsc);
        }, this);
        return {MIN : min, MAX : max};
    };
}
